import { studentRequests } from "api/studentApi";
import { useEffect } from "react";
import { useFormContext, useWatch } from "react-hook-form";
const { SelectInput, useGetList } = require("react-admin");

const AcademicYearInput = ({ defVal, readOnly, withoutLanguage = false }) => {
  const languageId = useWatch({ name: "instructionLanguageId" });
  const { setValue } = useFormContext();

  const { data, isLoading } = useGetList(studentRequests.getAcademicYearsSelect(), {});

  useEffect(() => {
    if (defVal) {
      setValue("academicYearId", defVal, { shouldDirty: false });
    } else if (!isLoading && data?.length) {
      setValue("academicYearId", data[0].id);
    }
  }, [isLoading, data, setValue, defVal]);

  if (!withoutLanguage && !languageId) return null;

  return (
    <SelectInput
      source="academicYearId"
      label="Учебна година"
      choices={data ?? []}
      isLoading={isLoading}
      readOnly={readOnly}
      optionText="name"
      optionValue="id"
      fullWidth
      filter=""
      isRequired
      emptyText={"Всички"}
      onChange={() => {
        setValue("studyTypeId", null);
        setValue("academicYearSessionId", null);
        setValue("disciplineId", null);
      }}
    />
  );
};

export default AcademicYearInput;
